export function formatPlanningImportMessage(result) {
  const updated = Number(result?.updated ?? 0);
  const created = Number(result?.created ?? 0);
  const skipped = Number(result?.skipped ?? 0);
  const parts = [];
  if (updated > 0) {
    parts.push(`${updated} mise(s) à jour`);
  }
  if (created > 0) {
    parts.push(`${created} créée(s)`);
  }
  if (skipped > 0) {
    parts.push(`${skipped} ignorée(s)`);
  }
  if (parts.length === 0) {
    return 'Import terminé : aucune ligne importée.';
  }
  return `Import terminé : ${parts.join(', ')}.`;
}
